import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.displaysteuerung-benutzer-zugriff';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungDisplaysteuerungBenutzerZugriffEffects {

    DisplaysteuerungBenutzerZugriff$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_DISPLAYSTEUERUNG_BENUTZER_ZUGRIFF),
        mergeMap((x: ac.GetDisplaysteuerungBenutzerZugriffAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getDisplaysteuerungBenutzerZugriff().pipe(
                map((result: any) => {
                    return new ac.GetDisplaysteuerungBenutzerZugriffErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetDisplaysteuerungBenutzerZugriffFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DisplaysteuerungQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DisplaysteuerungQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.DisplaysteuerungQueryService);
        }
        return this.service;
    }
}
